export const addresses = {
  providerAddress: "0x0AFd3ed6D9446352Cfe7A85ABc0dA94dc6f8C50a",
  sampleToken: "0xbD73226235E35CC70eFaC05eEb05B3DFa069Fb72",
};
